import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Testimonials = _resolveComponent("Testimonials")
  const _component_testimonial_modal = _resolveComponent("testimonial-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Testimonials, {
      testimonials: _ctx.testimonials,
      title: "Bekijk de situatie van anderen:",
      onTestimonial: _ctx.setPopupTestimonial
    }, null, 8, ["testimonials", "onTestimonial"]),
    _createVNode(_component_testimonial_modal, {
      modelValue: _ctx.currentPopupTestimonial,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.currentPopupTestimonial = $event))
    }, null, 8, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}